import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import {
  Button,
  Card,
  CardFilter,
  ProgressIndicator,
} from '@salesforce/design-system-react';
import { deleteJourney } from '../../actions';

const steps = [
	{ id: 0, label: 'Entry', },
	{ id: 1, label: 'Business Challenge' },
	{ id: 2, label: 'Personas' },
	{ id: 3, label: 'Milestones' },
  { id: 4, label: 'Milestone Connectors' },
  { id: 5, label: 'Product Overlays' },
];

const JourneyTable = (props) => {
  const [isFiltering, setIsFiltering] = useState(false);
  const [filteredItems, setFilteredItems] = useState([]);
  const isEmpty = props.items.length === 0;

  useEffect(() => {
    setFilteredItems(props.items);
  }, [isFiltering]);

  const handleFilterChange = (event) => {
    if (event.target.value) {
      setIsFiltering(true);
    } else {
      setIsFiltering(false);
    }
    const objectSearchKeys = Object.keys(props.items[0]);
    let filterKey = event.target.value && event.target.value.toLowerCase();

    let data = props.items;

    if (filterKey) {
      data = data.filter((row) => {
        if (objectSearchKeys.length > 0) {
          return objectSearchKeys.some((key) => {
            return String(row[key]).toLowerCase().indexOf(filterKey) > -1;
          });
        } else {
          return Object.keys(row).some((key) => {
            return String(row[key]).toLowerCase().indexOf(filterKey) > -1;
          });
        }
      });
    }

    setFilteredItems([...data]);
  };

  return (
    <div>
      <Card
      heading="My Demo Journeys"
      filter={
        !isEmpty && (
          <CardFilter
            placeholder="Search Journeys"
            onChange={handleFilterChange}
          />
        )
      }
    />
    <div className="slds-m-top_small slds-p-vertical_large" style={{ overflowX: 'scroll'}}>
      <div className="slds-grid">
        <Card 
          hasNoHeader 
          className="journeyCard slds-p-around_x-small slds-size_1-of-5 slds-m-horizontal_small slds-m-bottom_x-small" 
          style={{ boxShadow: 'rgb(60 64 67 / 25%) 0px 10.2626px 13.6834px', minWidth: '200px'}}
        >
          <div className="slds-align_absolute-center slds-text-heading_medium slds-p-bottom_xx-large" style={{ color: '#005fb2', fontWeight: '500'}}>Start A New Journey</div>
          <div className="slds-align_absolute-center slds-text-heading_small slds-p-top_xx-large" style={{ color: '#001639', fontWeight: '500'}}>Yes I've Completed</div>
          <div className="slds-align_absolute-center slds-text-heading_small slds-p-top_x-small" style={{ color: '#001639', fontWeight: '500'}}>
            <a href="https://salesforce.quip.com/nLb2AnTpluED">The Questionaire</a>
          </div>
          <div className="slds-align_absolute-center slds-p-top_xx-large">
            <Button
              style={{ 
                minWidth: '90px', 
                minHeight: '90px', 
                border: 'none',
                borderRadius: '50%',
                boxShadow: 'rgb(60 64 67 / 25%) 0px 10.2626px 13.6834px',
                backgroundImage: 'url(/icons/utility/add.svg)' ,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: '50% 50%',
              }}
              variant="brand"
              onClick={props.startJourney}
              className="slds-m-top_small slds-align_absolute-center"
            />
          </div>
          <div className="slds-p-top_x-large" />
        </Card>
            {filteredItems.map((item) => {
            return (
              <Card 
                hasNoHeader 
                className="journeyCard slds-p-around_x-small slds-size_1-of-5 slds-m-horizontal_small slds-m-bottom_x-small" 
                style={{ backgroundColor: '#001639', color: 'white', minWidth: '225px' }}
              >
                <div className="slds-align_absolute-center slds-text-heading_small" style={{ fontWeight: '500', overflowWrap: 'anywhere'}}>{item.journey_name.length > 25 ? item.journey_name.substring(0,30) + "..." : item.journey_name}</div>
                <div className="slds-grid slds-p-vertical_x-small">
                  <div className="slds-size_1-of-2 slds-align_absolute-center" style={{ borderRight: '1px solid #ddd'}}>{item.name}</div>
                  <div className="slds-size_1-of-2 slds-align_absolute-center">{new Date(item.created_at).toLocaleDateString()}</div>
                </div>
                <div className="slds-p-horizontal_medium">
                  <ProgressIndicator
                    id="vertical-progress-indicator"
                    completedSteps={steps.slice(0, item.navigation_stage + 1)}
                    onStepClick={null}
                    orientation="vertical"
                    steps={steps}
                    variant="modal"
                    selectedStep={item.navigation_stage}
                  />
                </div>
                <div className="slds-p-horizontal_medium slds-p-top_small slds-grid">
                  <div className="slds-col">
                    <Button
                      variant="success"
                      label="Update"
                      onClick={() => props.updateJourney(item.id)}
                    />
                  </div>
                  <div className="slds-col slds-align_absolute-center">
                    <Button
                      assistiveText={{ icon: 'Add Collaborator' }}
                      iconVariant="bare"
                      variant="icon"
                      iconCategory="utility"
                      iconName="adduser"
                      onClick={() => props.addCollaborators(item.id)}
                      style={{ color: '#f3f2f2'}}
                    />
                  </div>
                  <div className="slds-col slds-align_absolute-center">
                    <Button
                      assistiveText={{ icon: 'Create Quip' }}
                      iconVariant="bare"
                      variant="icon"
                      iconCategory="utility"
                      iconName="insert_template"
                      onClick={() => props.generateQuip(item.id)}
                      style={{ color: '#f3f2f2'}}
                    />
                  </div>
                  <div className="slds-col slds-align_absolute-center">
                    <Button
                      assistiveText={{ icon: 'Delete' }}
                      iconVariant="bare"
                      variant="icon"
                      iconCategory="utility"
                      iconName="delete"
                      style={{ fill: 'red !important'}}
                      onClick={() => props.deleteJourney(item.id)}
                      style={{ color: '#b22222'}}
                    />
                  </div>
                </div>
              </Card>
            )})}
      </div>
    </div>
  </div>
  )
};

JourneyTable.propTypes = {
  items: PropTypes.array,
};

export default JourneyTable;
